[
  {
    "id": "LOOP_DEV_EMPTY",
    "n": 0,
    "name": "EMPTY",
    "modelNumber": "EMPTY",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_ADDRESSABLE_MCP",
    "n": 36,
    "name": "CP3 Addressable Manual Call Point",
    "modelNumber": "ZT-CP3/AD",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_OPTICAL_STANDARD",
    "n": 7,
    "name": "Optical Smoke Detector",
    "modelNumber": "MKII-AOP",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": true,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_OPTO_HEAT",
    "n": 10,
    "name": "Combined Optical-Heat Detector",
    "modelNumber": "MKII-AOH",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": true,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_HEAT_A1S",
    "n": 3,
    "name": "Heat Detector (Rate of Rise)",
    "modelNumber": "MKII-AHR",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": true,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_HEAT_CS",
    "n": 4,
    "name": "Heat Detector (Fixed)",
    "modelNumber": "MKII-AHF",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": true,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_INPUT_MODULE",
    "n": 32,
    "name": "Input Module",
    "modelNumber": "ZAI-MI",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_IO_MODULE",
    "n": 29,
    "name": "Input/Output Module (Low Voltage)",
    "modelNumber": "ZAIO-MI",
    "modes": [
      "MODE_ENABLED",
      "MODE_INPUT_DISABLED",
      "MODE_OUTPUT_DISABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_IO_MAINS_MODULE",
    "n": 30,
    "name": "Input/Output Module (Mains Voltage)",
    "modelNumber": "ZAIOI/230",
    "modes": [
      "MODE_ENABLED",
      "MODE_INPUT_DISABLED",
      "MODE_OUTPUT_DISABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_ZONE_MODULE",
    "n": 33,
    "name": "Zone Monitor Module",
    "modelNumber": "ZAZM-MI",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_SOUNDER_MODULE",
    "n": 26,
    "name": "Sounder Circuit Controller",
    "modelNumber": "ZASC-MI",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_MCP_MONITOR",
    "n": 35,
    "name": "Mini Input Module (MCP)",
    "modelNumber": "SMM/C",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_XTRATONE_SOUNDER",
    "n": 17,
    "name": "Xtratone Sounder",
    "modelNumber": "MKII-AXT",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": true,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_XTRATONE_FLASHER",
    "n": 18,
    "name": "Xtratone Flasher",
    "modelNumber": "MKII-AXTF",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_XTRATONE_SOUNDER_FLASHER",
    "n": 19,
    "name": "Xtratone Sounder Beacon",
    "modelNumber": "MKII-AXTB",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_MAXITONE_SOUNDER",
    "n": 20,
    "name": "Raptor Sounder",
    "modelNumber": "ZRAP",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": true,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_MAXITONE_FLASHER",
    "n": 21,
    "name": "Maxitone Flasher",
    "modelNumber": "MKII-AMF",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": true,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_MAXITONE_SOUNDER_FLASHER",
    "n": 22,
    "name": "Raptor Sounder beacon",
    "modelNumber": "ZRAPB",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_SANDWICH_SOUNDER_FLASHER",
    "n": 25,
    "name": "Sandwich Sounder/Flasher",
    "modelNumber": "MKII-SSB",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_WIRELESS_BASE_STATION",
    "n": 34,
    "name": "Wireless Transponder",
    "modelNumber": "WF-TRA",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_WIRELESS_MCP",
    "n": 37,
    "name": "Wireless CP3 Addressable Manual Call Point",
    "modelNumber": "WF-MCP-RED",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_WIRELESS_OPTO",
    "n": 12,
    "name": "Wireless Optical Smoke Detector",
    "modelNumber": "WF-DET-OPT",
    "flags": {
      "heat": false,
      "smoke": true,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_WIRELESS_OPTO_HEAT",
    "n": 13,
    "name": "Wireless Combined Optical-Heat Detector",
    "modelNumber": "WF-DET-OPH",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": true,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_WIRELESS_HEAT_STATIC",
    "n": 6,
    "name": "Wireless Heat Detector (Fixed)",
    "modelNumber": "WF-DET-HTF",
    "flags": {
      "heat": true,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_WIRELESS_HEAT_ROR",
    "n": 5,
    "name": "Wireless Heat Detector (Rate of Rise)",
    "modelNumber": "WF-DET-HTR",
    "flags": {
      "heat": true,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_WIRELESS_SOUNDER",
    "n": 28,
    "name": "Wireless Maxitone Sounder",
    "modelNumber": "WF-SND",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_WIRELESS_IO_MODULE",
    "n": 31,
    "name": "Wireless Input/Output Interface (Low Voltage)",
    "modelNumber": "WF-IO",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_INPUT_DISABLED",
      "MODE_OUTPUT_DISABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_MIDITONE_SOUNDER",
    "n": 14,
    "name": "Miditone Sounder",
    "modelNumber": "MKII-AMD",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_MIDITONE_FLASHER",
    "n": 15,
    "name": "Miditone Flasher",
    "modelNumber": "MKII-AMF",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_MIDITONE_SOUNDER_FLASHER",
    "n": 16,
    "name": "Miditone Sounder/Flasher",
    "modelNumber": "MKII-AMSF",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_SANDWICH_SOUNDER",
    "n": 23,
    "name": "Sandwich Sounder",
    "modelNumber": "MKII-SSB",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_SANDWICH_FLASHER",
    "n": 24,
    "name": "Sandwich Flasher",
    "modelNumber": "MKII-SFB",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ]
  },
  {
    "id": "LOOP_DEV_OPTICAL_HIGH",
    "n": 8,
    "name": "High Sensitivity Optical Detector",
    "modelNumber": "RESERVED_1",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": true,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_OPTICAL_INTEGRATING",
    "n": 9,
    "name": "Integrating Optical Detector",
    "modelNumber": "RESERVED_2",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": true,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_OPTO_MULTI",
    "n": 11,
    "name": "Multi-sensor Optical Detector",
    "modelNumber": "RESERVED_3",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": true,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_FOUR_SOUNDER_MODULE",
    "n": 27,
    "name": "4 way Sounder Circuit Module",
    "modelNumber": "RESERVED_4",
    "modes": [
      "MODE_ENABLED",
      "MODE_BOTH_DISABLED"
    ],
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    }
  },
  {
    "id": "LOOP_DEV_UNKNOWN",
    "n": -1,
    "name": "UNKNOWN DEVICE, PLEASE PROVIDE DEVICE DATA",
    "modelNumber": "DEV-UNKNOWN",
    "flags": {
      "heat": false,
      "smoke": false,
      "optoHeat": false,
      "sounderTone": false,
      "isInput": false
    },
    "modes": []
  }
]